import React from "react";

export const HeavyRainIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="40" fill="#3F4447">
                <g transform="translate(1.000000, 10.000000)">
                    <rect
                        transform="translate(16.596194, 53.596194) rotate(45.000000) translate(-16.596194, -53.596194) "
                        x="15.0961941"
                        y="48.5961941"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(26.298097, 53.596194) rotate(45.000000) translate(-26.298097, -53.596194) "
                        x="24.798097"
                        y="48.5961941"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(36.000000, 54.000000) rotate(45.000000) translate(-36.000000, -54.000000) "
                        x="34.5"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(45.701903, 54.000000) rotate(45.000000) translate(-45.701903, -54.000000) "
                        x="44.201903"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(55.403806, 53.596194) rotate(45.000000) translate(-55.403806, -53.596194) "
                        x="53.9038059"
                        y="48.5961941"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <path
                        d="M0.5,29.6122449 C0.5,37.8398521 7.26573556,44.5 15.6,44.5 L59.8,44.5 C66.2564963,44.5 71.5,39.3383277 71.5,32.9591837 C71.5,30.4557696 70.6881793,28.0699692 69.2100015,26.0997886 C68.7128285,25.4371345 67.7726028,25.3029855 67.1099487,25.8001586 C66.4472946,26.2973316 66.3131456,27.2375572 66.8103186,27.9002114 C67.9026383,29.3561033 68.5,31.1116458 68.5,32.9591837 C68.5,37.6708191 64.6101126,41.5 59.8,41.5 L15.6,41.5 C8.91211925,41.5 3.5,36.1723436 3.5,29.6122449 C3.5,23.3011065 8.52355909,18.0914806 14.9178361,17.7430245 C15.6535009,17.7029345 16.2511413,17.1345121 16.328025,16.4017783 C17.0934185,9.1072567 23.3707983,3.5 30.9,3.5 C37.1116012,3.5 42.5810613,7.33352504 44.6700571,12.9706129 C44.9579254,13.7474162 45.8210123,14.1437763 46.5978156,13.855908 C47.3746188,13.5680397 47.770979,12.7049529 47.4831107,11.9281496 C44.9594855,5.11822839 38.3704544,0.5 30.9,0.5 C22.2638241,0.5 14.9814981,6.64434846 13.5172969,14.8649681 C6.14080192,15.8675997 0.5,22.1099533 0.5,29.6122449 Z"
                        fillRule="nonzero"
                    />
                    <path
                        d="M78.0882353,17.556928 C78.0882353,21.3972822 74.931951,24.5 71.0511919,24.5 L53.0558008,24.5 C52.9310635,24.5 52.8098824,24.4847743 52.6940146,24.45608 C49.1942267,24.0660882 46.5,21.136101 46.5,17.6070637 C46.5,14.0632713 49.2070859,11.1522169 52.682553,10.7592603 C53.9174545,6.52598399 57.8759323,3.5 62.4778874,3.5 C67.0605417,3.5 71.0101706,6.50171978 72.2604425,10.7160501 C75.5668832,11.2813452 78.0882353,14.1245115 78.0882353,17.556928 Z M71.0511853,21.5 C73.2864821,21.5 75.0882353,19.728825 75.0882353,17.556928 C75.0882353,15.3850309 73.2864821,13.6138559 71.0515049,13.6138559 C70.3183925,13.6140088 69.6938918,13.0876063 69.5703752,12.3674109 C68.9938517,9.00584147 66.0072687,6.5 62.4778874,6.5 C58.9125517,6.5 55.9055719,9.05615729 55.3699374,12.4614687 C55.248877,13.2311133 54.5587443,13.7799476 53.781605,13.7246045 C53.6837186,13.7176336 53.5851634,13.7141273 53.4860422,13.7141273 C51.2789192,13.7141273 49.5,15.4628557 49.5,17.6070637 C49.5,19.6371549 51.1010732,21.330239 53.169858,21.4880023 C53.2059513,21.4907547 53.2416656,21.4947691 53.2769589,21.5 L71.0511853,21.5 Z"
                        fillRule="nonzero"
                    />
                </g>
            </g>
        </g>
    </svg>
);
